import type { Provider } from '../types'

/**
 * Providers usable for eligibility work in a clinic context: admins see the
 * full org list (pre-#98 behavior); everyone else only doctors assigned to
 * their clinic. Dashboard's provider-selection effect's default and its
 * clinicProviders memo both encode this rule — keep them on one
 * implementation.
 */
export function filterToClinicScope(list: Provider[], isAdmin: boolean, clinicId: string | null | undefined) {
  return isAdmin || !clinicId ? list : list.filter(p => p.clinicIds.includes(clinicId))
}
